module.exports = __webpack_public_path__ + "86e6e89a5eff919eb56ec8ed9b47e7a9.svg";